import { render } from "./Technologies.vue?vue&type=template&id=0725d46e&scoped=true"
import script from "./Technologies.vue?vue&type=script&lang=js"
export * from "./Technologies.vue?vue&type=script&lang=js"

import "./Technologies.vue?vue&type=style&index=0&id=0725d46e&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0725d46e"]])

export default __exports__